import React from "react";
import { Row, Col, Container } from "reactstrap";
import FeatherIcon from "feather-icons-react";
import styled from "styled-components";
import axios from "axios";
import { BuscarEspecialista } from "../../API/Core";
import AsyncSelect from "react-select/async";
import Select from "react-select";

export default function FuncionName(props) {
  const [optionLoad, setOptionLoad] = React.useState([]);

  const loadOptions = async () => {
    try {
      let response = await BuscarEspecialista(props.id_alumno);
      let data = [];
      let results = response.data.variable1;
      console.log(results);
      for (let x = 0; x < results.length; x++) {
        data.push({
          label: `${results[x].variable2.toUpperCase()} (${results[
            x
          ].variable3.toLowerCase()})`,
          value: {
            materia: results[x].variable4,
            cedula: results[x].variable1,
            nombre: results[x].variable2,
            especialidad: results[x].variable3,
          },
        });
      }
      setOptionLoad(data);
      return data;
    } catch (err) {
      console.log(err);
    }
  };

  const tomarDatos = optionLoad;

  const handleOnchange = (e) => {
    if (e !== null) {
      props.onChange(e.value);
    } else {
      props.onChange(e);
    }
  };
  React.useEffect(() => {
    loadOptions();
  }, []);

  return (
    <FieldContainer>
      <Select
        defaultValue={{ label: "Seleccione Especialista", value: "vacio" }}
        options={tomarDatos}
        onChange={handleOnchange}
        theme={(theme) => ({
          ...theme,
          borderRadius: 0,
          colors: {
            ...theme.colors,
            primary50: "neutral10",
            primary: "silver",
          },
        })}
        // styles={{
        //     control: (provided, state) => ({
        //       ...provided,
        //       width: '50%', // Ajusta el ancho a 200px
        //     }),
        //   }}
      />
    </FieldContainer>
  );
}

const FieldContainer = styled.div`
  input {
    margin: 0 !important;
  }

  .react-select__menu * {
    font-size: 14px;
    text-transform: capitalize;
  }
`;
